import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTreeStore } from '../store/TreeStore';
import { scrollToElement } from '../utils/scrollTo';

export function ScrollToAnchor() {
  const location = useLocation();
  const procedureLoaded = useTreeStore((state) => state.procedureLoaded);
  const idForScrollFound = useTreeStore((state) => state.idForScrollFound);
  const setIdForScrollFound = useTreeStore((state) => state.setIdForScrollFound);
  const idForScroll = useTreeStore((state) => state.idForScroll);
  const setIdForScroll = useTreeStore((state) => state.setIdForScroll);

  const scrollToId = useCallback((elementId: string) => {
    scrollToElement(elementId);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.slice(1);
      setIdForScroll(elementId);
      scrollToId(elementId);
    }
  }, [location, procedureLoaded]);

  useEffect(() => {
    if (idForScrollFound) {
      scrollToId(idForScroll);
      setIdForScrollFound(false);
      setIdForScroll('');
    }
  }, [idForScrollFound]);

  return null;
}
